export default __webpack_public_path__ + "static/media/slider2.03ba9f91.jpg";